import React from "react";
import { useResource, useNavigation } from "@refinedev/core";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { PageHeader } from "@/components/ui/page-header";

interface ListPageProps {
  title?: string;
  children: React.ReactNode;
  createButtonProps?: {
    onClick?: () => void;
    hidden?: boolean;
    label?: string;
    disabled?: boolean;
    children?: React.ReactNode;
  };
  headerButtons?: React.ReactNode;
  canCreate?: boolean;
}

export const ListPage: React.FC<ListPageProps> = ({
  title,
  children,
  createButtonProps,
  headerButtons,
  canCreate = true,
}) => {
  const { resource } = useResource();
  const { create } = useNavigation();
  const displayTitle = title || resource?.meta?.label || resource?.name || "";

  return (
    <div>
      <PageHeader
        title={displayTitle}
        actions={
          <div className="flex items-center gap-2">
            {headerButtons}
            {canCreate && !createButtonProps?.hidden && (
              <Button
                onClick={createButtonProps?.onClick || (() => create(resource?.name ?? ""))}
                disabled={createButtonProps?.disabled}
              >
                {createButtonProps?.children ?? (
                  <>
                    <Plus className="mr-2 h-4 w-4" />
                    {createButtonProps?.label || "Create"}
                  </>
                )}
              </Button>
            )}
          </div>
        }
      />
      {children}
    </div>
  );
};
